import { StyledEngineProvider } from '@mui/material/styles';
import { useEffect } from 'react';
import ReactOnRails from 'react-on-rails/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { trackCoreWebVitals } from 'my-core/gtm-events';

import MainStyles from 'my-components/Root/MainStyles';
import TagManager from 'my-components/TagManager';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export default function MainApp() {
  const mainStore = ReactOnRails.getStore('mainStore');
  useEffect(() => {
    trackCoreWebVitals();
    window.dispatchAppMountedEvent?.();
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <LocalizationProvider dateAdapter={AdapterDateFns} localeText={LOCALE_OVERRIDES}>
        <Provider store={mainStore}>
          <BrowserRouter>
            <MainStyles />
            <TagManager />
          </BrowserRouter>
        </Provider>
      </LocalizationProvider>
    </StyledEngineProvider>
  );
}

const LOCALE_OVERRIDES = {
  // https://v6.mui.com/x/react-date-pickers/adapters-locale/#custom-field-placeholder
  // used for MONTH placeholder in picker fields - default `params.contentType === 'letter' ? 'MMMM' : 'MM'`
  fieldMonthPlaceholder: params => (params.contentType === 'digit' ? 'MM' : params.format),
};
